'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
OuterWrapper.displayName = 'OuterWrapper';
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
InnerWrapper.displayName = 'InnerWrapper';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Content = styled.div.attrs(_ref => {
  let {
    theme,
    ...props
  } = _ref;
  return {
    flex: false,
    ...props
  };
})`
  flex: 1 0 auto;

  ${_ref2 => {
  let {
    flex
  } = _ref2;
  return flex && `
    display: flex;
  `;
}};
`;
Content.displayName = 'Content';
const Wrapper = _ref3 => {
  let {
    children,
    ...otherProps
  } = _ref3;
  return /*#__PURE__*/_jsx(OuterWrapper, {
    ...otherProps,
    children: /*#__PURE__*/_jsx(InnerWrapper, {
      children: children
    })
  });
};
const GrowLayout = {
  Wrapper,
  Content
};
GrowLayout.displayName = 'GrowLayout';
export default GrowLayout;